module.exports = __webpack_public_path__ + "static/img/XR1.0c75c61a.png";